import { ChangeEvent } from 'react';
import { Input, Text, Box } from '@nimbus-ds/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

interface TimeInputBlockProps {
  day: string;
  index: number;
  dayIndex: number;
  type: 'start' | 'end';
  value: string;
  errors: Partial<Record<string, string>>;
  onChange: (e: ChangeEvent<HTMLInputElement>, index: number) => void;
}

function TimeInputBlock({
  day,
  index,
  dayIndex,
  type,
  value,
  errors,
  onChange,
}: Readonly<TimeInputBlockProps>): JSX.Element {
  const t = useTranslationShipping(
    'deliveryMethods.pickupPoints.form.secondStep.businessHours',
  );

  const errorKey = `${day}.${index}.${type}`;
  const fallbackErrorKey = `${index}.${type}`;
  const hasError = errors[errorKey] || errors[fallbackErrorKey];
  const errorMessage = errors[errorKey] || errors[fallbackErrorKey] || '';

  return (
    <Box>
      <Input
        type="time"
        name={type}
        onChange={(e) => onChange(e, dayIndex)}
        appearance={hasError ? 'danger' : 'neutral'}
        value={value}
        aria-label={`${t(day)} ${type} time ${dayIndex + 1}`}
      />
      {!!hasError && (
        <Text fontSize="caption" color="danger-textLow">
          {t(errorMessage)}
        </Text>
      )}
    </Box>
  );
}

export default TimeInputBlock;
